import { create } from "zustand";
import { ViewWLSubscriptionsTiers } from "../../../Common/models/subscriptions";
import { Promo } from "../../../Common/models/promos";

interface IFailedPaymentOfferModal {
  isOpen: boolean;
  showMembershipWarning: boolean;
}

interface IFailedPaymentsOffer {
  showFailedPayemntHeaderBanner: boolean;
  setShowFailedPayemntHeaderBanner: (state: boolean) => void;

  isLastFailedPaymentOffer: boolean;
  setIsLastFailedPaymentOffer: (state: boolean) => void;

  promoCode?: string;
  setPromoCode: (state: string) => void;

  validWLPromo: Promo | null;
  setValidWLPromo: (state: Promo | null) => void;

  isPercentOffer: boolean;
  setIsPercentOffer: (state: boolean) => void;

  failedPaymentSubscription: ViewWLSubscriptionsTiers | undefined;
  setFailedPaymentSubscription: (
    state: ViewWLSubscriptionsTiers | undefined
  ) => void;

  percentOffer: number | undefined;
  setPercentOffer: (state: number | undefined) => void;

  bonusEntries: number | undefined;
  setBonusEntries: (state: number | undefined) => void;

  promoPrice: number | undefined;
  setPromoPrice: (state: number | undefined) => void;

  resetStore: () => void;

  // modal states
  failedPaymentOfferModal: IFailedPaymentOfferModal;
  setFailedPaymentOfferModal: (state: IFailedPaymentOfferModal) => void;
}

const useFailedPaymentOfferStore = create<IFailedPaymentsOffer>((set) => ({
  showFailedPayemntHeaderBanner: false,
  setShowFailedPayemntHeaderBanner: (showFailedPayemntHeaderBanner) =>
    set({ showFailedPayemntHeaderBanner }),

  promoCode: undefined,
  setPromoCode: (promoCode) => set({ promoCode }),

  validWLPromo: null,
  setValidWLPromo: (validWLPromo) => set({ validWLPromo }),

  failedPaymentSubscription: undefined,
  setFailedPaymentSubscription: (failedPaymentSubscription) =>
    set({ failedPaymentSubscription }),

  isPercentOffer: true,
  setIsPercentOffer: (isPercentOffer) => set({ isPercentOffer }),

  percentOffer: undefined,
  setPercentOffer: (percentOffer) => set({ percentOffer }),

  bonusEntries: undefined,
  setBonusEntries: (bonusEntries) => set({ bonusEntries }),

  promoPrice: undefined,
  setPromoPrice: (promoPrice) => set({ promoPrice }),

  isLastFailedPaymentOffer: false,
  setIsLastFailedPaymentOffer: (isLastFailedPaymentOffer) =>
    set({ isLastFailedPaymentOffer }),

  failedPaymentOfferModal: {
    isOpen: false,
    showMembershipWarning: false,
  },
  setFailedPaymentOfferModal: (failedPaymentOfferModal) =>
    set({ failedPaymentOfferModal }),

  resetStore: () => {
    return set({
      showFailedPayemntHeaderBanner: false,
      isLastFailedPaymentOffer: false,
      failedPaymentOfferModal: {
        isOpen: false,
        showMembershipWarning: false,
      },
      promoCode: undefined,
      validWLPromo: null,
      failedPaymentSubscription: undefined,
      isPercentOffer: true,
      percentOffer: undefined,
      promoPrice: undefined,
      bonusEntries: undefined,
    });
  },
}));

export default useFailedPaymentOfferStore;
